import { isValidHomeDepotItemId } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const HomeDepotReviewsContent: SDEContent = {
  projectType: 'async_homedepot_reviews',
  projectCategory: 'homedepot',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/homedepot/reviews/v1`;
  },
  docsSection: 'homedepot-reviews-api',
  docsSectionTitle: 'Home Depot Reviews API',
  docsSectionAsync: 'homedepot-reviews-api-async',
  docsSectionAsyncTitle: 'Home Depot Reviews API (Async)',
  inputKey: 'item_id',
  inputsKey: 'item_ids',
  validatorFunction: isValidHomeDepotItemId,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Item IDs',
      listLiteralInputPlaceholder: 'Enter one Home Depot item ID per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: "Input item ID",
      inputSectionDescription: "Enter Home Depot item IDs in the input field or upload a CSV with your item IDs to begin scraping Home Depot reviews.",
    },
    projectContent: {
      title: 'Home Depot reviews',
      description: 'Extract well-structured customer reviews from a Home Depot product page like rating, title, text, author and date.',
      icon: 'homedepot',
      inputTitle: 'Item ID',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input item ID',
      inputSectionDescription: 'Enter Home Depot item IDs to begin scraping Home Depot reviews.',
    },
    projectContent: {
      title: 'Home Depot reviews',
      description: 'Extract well-structured customer reviews from a Home Depot product page.',
      icon: 'homedepot',
    },
    enterInputsPlaceholder: '320326855',
    enterInputsMessage: 'Enter item ID for scraping',
    codeViewPlaceHolder: 'Please provide a valid item ID',
    dropdownTitle: 'Home Depot Reviews'
  }
};
